import { toObjectMap } from "@@/utilities/dictionary";

const bookableTypes = ["GENERIC", "TABLE_BOOKING", "RENTAL"] as const;
type BookableType = (typeof bookableTypes)[number];
const bookableType = toObjectMap<BookableType>([...bookableTypes]);

const isTableBooking = (
    type: BookableType | undefined,
): type is "TABLE_BOOKING" => type === "TABLE_BOOKING";
const _isGeneric = (type: BookableType | undefined): type is "GENERIC" =>
    type === "GENERIC";

export type { BookableType };
export { bookableType, bookableTypes };
export { isTableBooking };
